export default __webpack_public_path__ + "assets/img/ic-close-red.e0e10cfaaf452fa1341669792b49971d.svg";